export default __webpack_public_path__ + "static/media/clapingo-afiliate.6dc45e6f.svg";